import { useRef, memo, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase, ClickAwayListener, InputBase, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import { i18n } from '../../../../language';
import lengthVerification from '../../../../utils/lengthVerification';
import { DeleteIcon, MoreIcon } from '../../../../components/Icon';
import { Delete } from './list';

const useStyles = makeStyles((theme) => ({
  root: {},
  body: {
    maxWidth: '100%',
    height: '3.75rem',
    padding: '0.625rem 0 0.625rem 1.25rem',
    borderRadius: '0.7875rem',
    boxShadow: '0 0 0.625rem 0 rgba(125, 134, 169, 0.2)',
    backgroundColor: theme.palette.font.white,
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      position: 'absolute',
      top: '0',
      left: '0',
      content: '""',
      display: 'block',
      width: '0.313rem',
      height: '3.75rem',
      backgroundColor: '#c0c6cb',
      zIndex: '9',
    },
  },
  Strip: {
    height: '0.625rem',
    borderRadius: '0.475rem',
    backgroundColor: '#F4F4F5',
  },
  title: {
    height: '3.563rem',
    width: '17.188rem',
    backgroundColor: '#4073d2',
    borderRadius: '10.1px',
    padding: '0.875rem 0.938rem 0.75rem 1.563rem',
    marginBottom: '0.875rem',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'NotoSans-Medium',
    fontSize: '1.423rem',
    letterSpacing: 0,
    color: theme.palette.font.white,
    fontWeight: '600',
  },
  iconBox: {
    position: 'relative',
    width: '1.5rem',
    height: '1.5rem',
    marginLeft: '1rem',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '200%',
      height: '100%',
    },
  },
  icon: {
    fontSize: '1.125rem',
    color: '#c0c6cb',
  },
  popper: {
    '&::before': {
      position: 'absolute',
      top: '-0.688rem',
      left: '48%',
      content: '""',
      display: 'block',
      borderBottom: '0.688rem solid #fff',
      borderLeft: '0.688rem solid transparent',
      borderRight: '0.688rem solid transparent',
      width: '1.376rem',
      height: '0.688rem',
      zIndex: '10',
    },
    '&::after': {
      position: 'absolute',
      top: '-0.688rem',
      left: '48%',
      content: '""',
      display: 'block',
      borderBottom: '0.8rem solid rgba(0,0,0,0.03)',
      borderLeft: '0.8rem solid transparent',
      borderRight: '0.8rem solid transparent',
      width: '1.6rem',
      height: '0.8rem',
      zIndex: '0',
    },
  },
  iconbox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '1.063rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  menuList: {
    width: '13.313rem',
    padding: '0',
  },
  deleteIcon: {
    fontSize: '1.25rem',
    color: '#525e6c',
  },
  deleteBox: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.938rem',
  },
  menuItem: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '0.875rem',
    color: '#2e4469',
    fontWeight: '500',
    height: '3.75rem',
  },
}));

export default memo(function Card({
  title,
  accept,
  index,
  triggerFunction,
  reName,
  focusCheck,
  id,
  errorMsg,
  delectListDate,
  smartComm
}) {
  const classes = useStyles();
  const anchorRef = useRef(null);
  const ref = useRef(null);
  const error = errorMsg?.[id]?.[i18n.t('DUTYASSIGN_TEMPLATE_DUTYIC')];
  const [open, setOpen] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef?.current?.contains(event.target)) {
      return;
    }
    setDeleteDialogOpen(true);
    setOpen(false);
  };

  const handleDelete = () => {
    delectListDate();
  };

  const handleOnChang = (event) => {
    if (lengthVerification(event.target.value, 16)) {
      return;
    }
    reName(event.target.value);
  };

  return (
    <div className={classes.root} ref={ref}>
      <Delete
        open={deleteDialogOpen}
        id="DutyAssign-Delete-afv"
        setopen={setDeleteDialogOpen}
        handleDelete={handleDelete}
      />
      <Popper
        className={classes.popper}
        open={open}
        id="DutyAssign-Popper-afw"
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        style={{ zIndex: '10000' }}
      >
        <Paper>
          <ClickAwayListener onClickAway={handleClose}>
            <MenuList autoFocusItem={open} id="DutyAssign-MenuList-afy" className={classes.menuList}>
              <MenuItem onClick={handleClose} id="DutyAssign-MenuItem-afz" className={classes.menuItem}>
                <div className={classes.deleteBox}>
                  <DeleteIcon className={classes.deleteIcon} />
                </div>
                {i18n.t('DUTYASSIGN_MYTEMPLATE_EDIT_CUBICLE_DELETE')}
              </MenuItem>
            </MenuList>
          </ClickAwayListener>
        </Paper>
      </Popper>
      <InputBase
        className={classes.title}
        value={title}
        style={error ? { border: 'solid 1px #f44336' } : {}}
        onChange={handleOnChang}
        id={`DutyAssign-InputBase-aga-${id}`}
        onBlur={focusCheck(i18n.t('DUTYASSIGN_TEMPLATE_DUTYIC'), title, id)}
        endAdornment={
          <ButtonBase
            ref={anchorRef}
            className={classes.iconBox}
            onClick={handleToggle}
            id={`DutyAssign-dropDown-aga-${id}`}
          >
            <MoreIcon className={classes.icon} />
          </ButtonBase>
        }
      />
      <div className={classes.body}>
        <div className={classes.Strip} style={{ width: '13.875rem' }} />
        <div className={classes.Strip} style={{ width: '8.5rem', margin: '0.313rem 0' }} />
        <div className={classes.Strip} style={{ width: '2.938rem' }} />
      </div>
    </div>
  );
});
